var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({class:[_vm.data.staticClass, 'el-divider', ("el-divider--" + (_vm.props.direction))]},'div',_vm.data.attrs,false),_vm.listeners),[(_vm.slots().default && _vm.props.direction !== 'vertical')?_c('div',{class:['el-divider__text', ("is-" + (_vm.props.contentPosition))]},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a67b929e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/packages/divider/src/main.vue
// module id = null
// module chunks = 